export const TYPE_CARD = 0;
export const TYPE_BANK = 1;
export const TYPE_MANUAL = 10;

export const DISPLAY_NAME_REAL = 0; // 本名
export const DISPLAY_NAME = 1; // 管理名
export const DISPLAY_NAME_VIEW = 2; // 表記名

export const DISPLAY_SHOW = 0; // 表示
export const DISPLAY_HIDE = 1; // 非表示